$(document).ready(function() {
    if($('.causes-prevention-slider').length > 0){
        function setCauseHeight(){
            let causeHeight = 0;
            $('.slider-cause').each(function(){ 
                if($(this).outerHeight() > causeHeight){
                    causeHeight = $(this).outerHeight();
                }
            });
            $('.slider-cause').outerHeight(causeHeight);
            $('.causes-prevention-sticky .causes-title').outerHeight(causeHeight);
        }
        function setPreventionHeight(){
            let preventionHeight = 0;
            $('.slider-prevention').each(function(){ 
                if($(this).outerHeight() > preventionHeight){
                    preventionHeight = $(this).outerHeight();
                }
            });
            $('.slider-prevention').outerHeight(preventionHeight);
            $('.causes-prevention-sticky .prevention-title').outerHeight(preventionHeight);
        }
        
        let causesPrevention;
        function causesPreventionSlider(){
            $('.slider-cause').removeAttr('style');
            $('.slider-prevention').removeAttr('style');
            if(causesPrevention){
                causesPrevention.destroy();
            }
            causesPrevention = new Flickity('.causes-prevention-slider', {
                cellAlign: 'left',
                contain: true,
                wrapAround: false,
                pageDots: false,
                groupCells: true,
                draggable: true,
                prevNextButtons: true,
                on: {
                    ready: function(){
                        setCauseHeight();
                        setPreventionHeight();
                    }
                }
            });
        }
        causesPreventionSlider();
        $(window).on('resize', function(){
            causesPreventionSlider();
        });
    }

});